<template>
  <div id="agent-dashboard">
    <div class="align-center justify-center btn-refresh" @click="onRefresh">
      <icon-base icon-color="#6B6F80" icon-hover-color="#6B6F80" style="padding-right: 6px">
        <icon-refresh/>
      </icon-base>
      <span>Refesh</span>
    </div>
    <div class="agent-dashboard-header">
      <div class="overview-number" style="background-color: #4375F4">
        <span class="number">{{ totalAgents }}</span>
        <span class="label">Total Agents</span>
      </div>
      <div class="overview-number" style="background-color: #45C08C">
        <span class="number">{{ availableAgents }}</span>
        <span class="label">Total Available</span>
      </div>
      <div class="overview-number" style="background-color: #888888">
        <span class="number">{{ unAvailableAgents }}</span>
        <span class="label">Total Unavailable</span>
      </div>
    </div>
    <div class="filter-box">
      <v-text-field outline flat desense hide-details height="38" placeholder="Search agent..." v-model="search">
        <template v-slot:prepend-inner>
          <icon-base icon-color="#6B6F80" icon-hover-color="#6B6F80">
            <icon-search/>
          </icon-base>
        </template>
      </v-text-field>
      <div class="filter-input">
        <v-autocomplete outline flat dense hide-details height="38" :items="roleItems" v-model="role"
                        placeholder="Role" item-text="text"
                        item-value="value">
        </v-autocomplete>
      </div>
      <div class="filter-input">
        <v-autocomplete outline flat dense hide-details height="38" :items="statusItems" v-model="status"
                        placeholder="Status" item-text="text"
                        item-value="value">
        </v-autocomplete>
      </div>
    </div>
    <div class="details">
      <table>
        <thead>
        <tr>
          <th>
            <div class="header-sort">
              <span>Agent</span>
              <v-btn icon @click="toggleSortAgent">
                <icon-base style="cursor: pointer" icon-color="#6B6F80" icon-hover-color="#6B6F80">
                  <icon-sort/>
                </icon-base>
              </v-btn>
            </div>
          </th>
          <th>
            <div class="header-sort">
              <span>Status</span>
              <v-btn icon @click="toggleSortStatus">
                <icon-base style="cursor: pointer" icon-color="#6B6F80" icon-hover-color="#6B6F80">
                  <icon-sort/>
                </icon-base>
              </v-btn>
            </div>
          </th>
          <th>
            <div class="header-sort">
              <span>Role</span>
              <v-btn icon @click="toggleSortRole">
                <icon-base style="cursor: pointer" icon-color="#6B6F80" icon-hover-color="#6B6F80">
                  <icon-sort/>
                </icon-base>
              </v-btn>
            </div>
          </th>
          <th>
            <div class="header-sort">
              <span>Supporting</span>
              <v-btn icon>
                <icon-base style="cursor: pointer" icon-color="#6B6F80" icon-hover-color="#6B6F80">
                  <icon-sort/>
                </icon-base>
              </v-btn>
            </div>
          </th>
        </tr>
        </thead>
        <tbody id="scroll-body">
        <tr v-for="agent in filteredAgent" :key="agent.id">
          <td>{{ agent.email }}</td>
          <td>
            <div class="status" v-if="agent.auto_assign_config.active">
              <v-avatar size="10" color="#45C08C"></v-avatar>
              Available
            </div>
            <div class="status" v-else>
              <v-avatar size="10" color="#888888"></v-avatar>
              Unavailable
            </div>
          </td>
          <td>{{ agent.role_description }}</td>
          <td>{{ agent.supporting || 0 }}</td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import IconSearch from "components/icons/IconSearch";
import IconBase from "components/icons/IconBase";
import IconRefresh from "components/icons/IconRefresh";
import IconSort from "components/icons/IconSort";
import StaffService from "@/services/staff.service";
import {mapActions, mapState} from "vuex";
import * as _ from "lodash"

export default {
  name: "AgentDashboard",
  components: {IconSort, IconSearch, IconBase, IconRefresh},
  data() {
    return {
      search: '',
      status: '',
      role: '',
      statusItems: [
        'All',
        'Available',
        'Unavailable'
      ],
      roleItems: [
          'Bot Owner',
          'Bot Admin',
          'Customer Support Lead',
          'Customer Supporter'
      ],
      sortAgentColumn: null,
      sortStatus: 'desc',
      sortRole: null,
      agentSupporting: null,
    }
  },
  mounted() {
    this.refreshInterval()
  },
  computed: {
    ...mapState('autoAssign', ['autoAssignCfg']),
    totalAgents() {
      return this.autoAssignCfg.supporters.length
    },
    availableAgents() {
      return this.autoAssignCfg.supporters.filter(o => o.auto_assign_config.active).length
    },
    unAvailableAgents() {
      return this.autoAssignCfg.supporters.filter(o => !o.auto_assign_config.active).length
    },
    filteredAgent() {
      let supporters = this.autoAssignCfg.supporters;
      //Filter status
      supporters = supporters.filter(o => {
        switch (this.status) {
          case 'Available':
            return o.auto_assign_config.active;
          case 'Unavailable':
            return !o.auto_assign_config.active;
          default:
            return true
        }
      })
      //Filter agent
      supporters = supporters.filter(o=> o.email.toLowerCase().includes(this.search.toLowerCase()))
      //Filter role
      if (this.role) {
        supporters = supporters.filter(o=> o.role_description === this.role)
      }
      //Sort
      if (this.sortAgentColumn) {
        supporters = _.orderBy(supporters, ["email"], [this.sortAgentColumn])
      }
      if (this.sortStatus) {
        supporters = _.orderBy(supporters, ["auto_assign_config.active", "email"], [this.sortStatus, "asc"])
      }
      if (this.sortRole) {
        supporters = _.orderBy(supporters, ["role_description"], [this.sortRole])
      }

      // map supporting count
      for (let i = 0; i < supporters.length; i++) {
        const agent = supporters[i];
        // console.log('agentSupporting[agent.id.toString()]', this.agentSupporting[agent.id.toString()])
        let supportingInfo = this.agentSupporting ? this.agentSupporting[agent.id.toString()] : null;
        agent.supporting = supportingInfo ? supportingInfo.supporting : 0;
      }
      return supporters
    }
  },
  methods: {
    ...mapActions('autoAssign', ['fetchCurrentAutoAssignCfg']),
    async onRefresh() {
      await this.getAgentSupporting();
      this.fetchCurrentAutoAssignCfg()
    },
    refreshInterval() {
      this.onRefresh()
      setTimeout(() => {
        this.refreshInterval()
      }, 60 * 1000)
    },
    toggleSortAgent() {
      this.sortAgentColumn = this.sortAgentColumn === 'asc' ? 'desc': 'asc';
      this.sortRole = null;
      this.sortStatus = null;
    },
    toggleSortStatus() {
      this.sortStatus = this.sortStatus === 'asc' ? 'desc': 'asc';
      this.sortRole = null;
      this.sortAgentColumn = null;
    },
    toggleSortRole() {
      this.sortRole = this.sortRole === 'asc' ? 'desc': 'asc';
      this.sortAgentColumn = null;
      this.sortStatus = null;
    },
    async getAgentSupporting() {
      this.agentSupporting = await StaffService.getAgentSupporting(this.$route.params.bot_code);
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep.v-text-field--outline > .v-input__control > .v-input__slot {
  min-height: 38px;
}

::v-deep.theme--light.v-text-field--outline > .v-input__control > .v-input__slot {
  border: 1px solid #D9D9D9 !important;
}

::v-deep.v-autocomplete.v-text-field--enclosed:not(.v-text-field--solo):not(.v-text-field--single-line) .v-select__slot > input {
  margin-top: 0 !important;
}

::v-deep.v-text-field--outline > .v-input__control > .v-input__slot {
  background-color: white !important;
}

::v-deep.v-text-field .v-input__append-inner {
  margin-top: 8px !important;
}

::v-deep.v-text-field .v-input__prepend-inner {
  margin-top: 8px !important;
}

::v-deep input {
  font-size: 14px;
  margin-top: 2px !important;
  padding-left: 6px !important;
}

::v-deep i {
  font-size: 20px !important;
}

#agent-dashboard {
  background-color: white;
  border-radius: 5px;
  margin: 10px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  .btn-refresh {
    display: flex;
    padding-left: 10px;
    cursor: pointer;
    justify-content: flex-end;
    span {
      font-size: 12px;
      color: #6B6F80
    }
  }
  .agent-dashboard-header {
    display: flex;
    gap: 20px;

    .overview-number {
      padding: 20px;
      height: 88px;
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      color: white;

      .number {
        font-size: 24px;
        font-weight: bold;
        line-height: 1.2;
      }

      .label {
        font-size: 16px;
        line-height: 1.2;
      }
    }
  }

  .filter-box {
    display: flex;
    gap: 20px;

    .filter-input {
      max-width: 150px;
    }
  }

  .details {
    flex-grow: 1;
    position: relative;
    min-height: 350px;

    table {
      width: 100%;
      border-collapse: collapse;
      border: 1px solid #EDEEF3;
      table-layout: fixed;
      display: block;
      height: 100%;

      tr {
        display: table;
        width: 100%;
      }

      thead {
        width: 100%;
        display: table;

        th {
          text-align: left;
          background-color: #F8F8F8;
          height: 40px;
          padding: 0 10px;
          border-bottom: 1px solid #EDEEF3;
          width: 33.33%;
          color: #141519;
        }

        .header-sort {
          display: flex;
          justify-content: space-between;
          align-items: center;
        }
      }

      #scroll-body::-webkit-scrollbar-thumb {
        visibility: hidden !important;
      }

      #scroll-body:hover::-webkit-scrollbar-thumb {
        visibility: visible !important;
        background-color: #0000001a;
        opacity: 0.1;
        border-radius: 100px;
      }

      #scroll-body::-webkit-scrollbar {
        background-color: white;
        width: 6px;
      }

      tbody {
        width: 100%;
        display: block;
        height: calc(100% - 40px);
        overflow-y: auto;
        position: absolute;

        .status {
          display: flex;
          align-items: center;
          gap: 6px;
        }

        td {
          width: 33.33%;
          padding: 10px;
          border-bottom: 1px solid #EDEEF3;
        }
      }
    }
  }
}
</style>